import React, { useEffect, useState } from "react"
import * as St from "./index.styled"
import * as StTable from "./styled/table.styled"
import * as StCard from "./styled/card.styled"
import { v4 as uuidv4 } from "uuid"
import CustomBlockButton from "../../../components/button/CustomBlockButton"
import { CustomDialog } from "../../../components/dialog/v1/CustomDialog"
import { CustomLabelInput } from "../../../components/input/CustomLabelInput"
import { SellertoolSignatureUtils } from "../../../utils/sellertool-signature-utils"
import { useApiInfoContextValueHook } from "../../../contexts/ApiInfoContextProvider"
import axios from "axios"
import { customToast } from "../../../components/toast/custom-react-toastify/v1"
import { CustomBackdropController } from "../../../components/backdrop/default/v1"
import { WegetSettingRackLocationModal } from "./wegets/weget-setting-rack-location-modal"
import { WegetSearchLocation } from "./wegets/weget-search-location"
import { WegetEditLocationTypeModal } from "./wegets/weget-edit-location-type-modal"
import { useNavigate } from "react-router-dom"
import { WegetMoveItemsModal } from "./wegets/weget-move-items-modal"
import { WegetBackupModal } from "./wegets/weget-backup-modal"
import { Menu, MenuItem } from "@mui/material"

const API_HOST = process.env.REACT_APP_MAIN_API_HOST

export function MainView(props) {
    const apiInfoContextValueHook = useApiInfoContextValueHook()
    const navigate = useNavigate()

    const [rackLocations, setRackLocations] = useState([])
    const [createRackLocationModalOpen, setCreateRackLocationModalOpen] = useState(false)

    const [settingRackLocationModalOpen, setSettingRackLocationModalOpen] = useState(false)
    const [targetRackLocation, setTargetRackLocation] = useState(null)
    const [addressSearchQueryDatas, setAddressSearchQueryDatas] = useState({
        rack: "",
        bay: "",
        level: "",
        position: "",
    })
    const [conditionSearchQueryDatas, setConditionSearchQueryDatas] = useState({
        productName: "",
        optionName: "",
        optionCode: "",
    })
    const [locationTypeSearchQuery, setLocationTypeSearchQuery] = useState("ALL") // ALL, NORMAL, INVENTORY

    const [selectedRackLocations, setSelectedRackLocations] = useState([])
    const [editLocationTypeModalOpen, setEditLocationTypeModalOpen] = useState(false)

    const [moveItemsModalOpen, setMoveItemsModalOpen] = useState(false);
    const [backupModalOpen, setBackupModalOpen] = useState(false);

    useEffect(() => {
        handleReqFetchRackLocations()
    }, [])

    const handleReqFetchRackLocations = async () => {
        const timestamp = Date.now().toString()
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp,
        })

        const headers = {
            "x-sellertool-apiKey": apiInfoContextValueHook?.apiInfo?.apiKey,
            "x-sellertool-timestamp": timestamp,
            "x-sellertool-signiture": signature,
        }

        CustomBackdropController().showBackdrop()
        const fetchResult = await axios
            .get(`${API_HOST}/rack-locations`, {
                headers: headers,
            })
            .then((res) => {
                return {
                    res: res,
                    content: res.data?.content,
                }
            })
            .catch((err) => {
                customToast.error(err.response)
            })

        if (fetchResult?.content) {
            setRackLocations(fetchResult?.content)
            setSelectedRackLocations((prev) => {
                return prev.map((rackLocation) => {
                    const target = fetchResult?.content?.find((r) => r.uuid === rackLocation?.uuid)
                    if (target) {
                        return { ...target }
                    } else {
                        return { ...rackLocation }
                    }
                })
            })
        }

        CustomBackdropController().hideBackdrop()
    }

    const handleOpenCreateRackLocationModal = () => {
        setCreateRackLocationModalOpen(true)
    }

    const handleCloseCreateRackLocationModal = () => {
        setCreateRackLocationModalOpen(false)
    }

    const handleOpenSettingRackLocationModal = (rackLocation) => {
        setSettingRackLocationModalOpen(true)
        setTargetRackLocation(rackLocation)
    }

    const handleCloseSettingRackLocationModal = () => {
        setSettingRackLocationModalOpen(false)
        setTargetRackLocation(null)
    }

    const handleOpenMoveItemsModal = (rackLocation) => {
        setMoveItemsModalOpen(true)
        setTargetRackLocation(rackLocation)
    }

    const handleCloseMoveItemsModal = () => {
        setMoveItemsModalOpen(false)
        setTargetRackLocation(null)
    }

    const handleOpenBackupModal = (rackLocation) => {
        setBackupModalOpen(true)
        setTargetRackLocation(rackLocation)
    }

    const handleCloseBackupModal = () => {
        setBackupModalOpen(false)
        setTargetRackLocation(null)
    }

    const handleSelectRackLocation = (rLocation) => {
        setSelectedRackLocations((prev) => {
            if (prev?.find((r) => r.uuid === rLocation?.uuid)) {
                return prev?.filter((r) => r.uuid !== rLocation?.uuid)
            }
            return prev?.concat(rLocation)
        })
    }

    // 카드 펼침/접힘 상태 (uuid Set)
    const [expandedLocationUUIDs, setExpandedLocationUUIDs] = useState(() => new Set())

    const handleToggleExpand = (uuid) => {
        setExpandedLocationUUIDs((prev) => {
            const next = new Set(prev)
            if (next.has(uuid)) {
                next.delete(uuid)
            } else {
                next.add(uuid)
            }
            return next
        })
    }

    const handleExpandAll = (uuids) => {
        setExpandedLocationUUIDs(new Set(uuids))
    }

    const handleCollapseAll = () => {
        setExpandedLocationUUIDs(new Set())
    }

    // 상단 고정 바의 검색 패널 펼침 여부
    const [searchOpen, setSearchOpen] = useState(true)

    // 카드 액션 메뉴(설정/이동/백업) popper
    const [actionMenu, setActionMenu] = useState({ anchorEl: null, rackLocation: null })

    const handleOpenActionMenu = (e, rackLocation) => {
        e.stopPropagation()
        setActionMenu({ anchorEl: e.currentTarget, rackLocation })
    }

    const handleCloseActionMenu = () => {
        setActionMenu({ anchorEl: null, rackLocation: null })
    }

    const handleActionMenuSelect = (action) => {
        const rackLocation = actionMenu.rackLocation
        handleCloseActionMenu()
        if (!rackLocation) {
            return
        }
        if (action === "setting") {
            handleOpenSettingRackLocationModal(rackLocation)
        } else if (action === "move") {
            handleOpenMoveItemsModal(rackLocation)
        } else if (action === "backup") {
            handleOpenBackupModal(rackLocation)
        }
    }

    const handleOpenEditLocationTypeModal = () => {
        setEditLocationTypeModalOpen(true)
    }

    const handleCloseEditLocationTypeModal = () => {
        setEditLocationTypeModalOpen(false)
    }

    const handleAddNewRackLocations = async (newRackLocations) => {
        const timestamp = Date.now().toString()
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp,
        })

        const headers = {
            "x-sellertool-apiKey": apiInfoContextValueHook?.apiInfo?.apiKey,
            "x-sellertool-timestamp": timestamp,
            "x-sellertool-signiture": signature,
        }

        const body = {
            rackLocations: newRackLocations,
        }

        CustomBackdropController().showBackdrop()
        const addResult = await axios
            .post(`${API_HOST}/rack-locations/bulk-add`, body, {
                headers: headers,
            })
            .then((res) => {
                return {
                    res: res,
                    content: res.data?.content,
                }
            })
            .catch((err) => {
                customToast.error(err.response)
            })

        if (addResult?.content) {
            await handleReqFetchRackLocations()
            handleCloseCreateRackLocationModal()
        }
        CustomBackdropController().hideBackdrop()
    }

    const handleUpdateRackLocation = async (newRackLocation) => {
        const timestamp = Date.now().toString()
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp,
        })

        const headers = {
            "x-sellertool-apiKey": apiInfoContextValueHook?.apiInfo?.apiKey,
            "x-sellertool-timestamp": timestamp,
            "x-sellertool-signiture": signature,
        }

        const body = {
            rackLocation: newRackLocation,
        }

        CustomBackdropController().showBackdrop()
        const addResult = await axios
            .put(`${API_HOST}/rack-locations/update-one`, body, {
                headers: headers,
            })
            .then((res) => {
                return {
                    res: res,
                    content: res.data?.content,
                }
            })
            .catch((err) => {
                customToast.error(err.response)
            })

        if (addResult?.content) {
            await handleReqFetchRackLocations()
            handleCloseEditLocationTypeModal()
        }
        CustomBackdropController().hideBackdrop()
    }

    const handleUpdateRackLocations = async (newRackLocations) => {
        const timestamp = Date.now().toString()
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp,
        })

        const headers = {
            "x-sellertool-apiKey": apiInfoContextValueHook?.apiInfo?.apiKey,
            "x-sellertool-timestamp": timestamp,
            "x-sellertool-signiture": signature,
        }

        const body = {
            rackLocations: newRackLocations,
        }

        CustomBackdropController().showBackdrop()
        const addResult = await axios
            .put(`${API_HOST}/rack-locations/bulk-update`, body, {
                headers: headers,
            })
            .then((res) => {
                return {
                    res: res,
                    content: res.data?.content,
                }
            })
            .catch((err) => {
                customToast.error(err.response)
            })

        if (addResult?.content) {
            await handleReqFetchRackLocations()
            handleCloseEditLocationTypeModal()
        }
        CustomBackdropController().hideBackdrop()
    }

    const handleSaveTargetRackLocation = async (newRackLocation) => {
        await handleUpdateRackLocation(newRackLocation)
    }

    const handleDeleteRackLocation = async () => {
        const timestamp = Date.now().toString()
        const signature = SellertoolSignatureUtils().generateSigniture({
            apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
            secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
            timestamp: timestamp,
        })

        const headers = {
            "x-sellertool-apiKey": apiInfoContextValueHook?.apiInfo?.apiKey,
            "x-sellertool-timestamp": timestamp,
            "x-sellertool-signiture": signature,
        }

        CustomBackdropController().showBackdrop()
        const addResult = await axios
            .delete(`${API_HOST}/rack-locations/${targetRackLocation?.id}`, {
                headers: headers,
            })
            .then((res) => {
                return {
                    res: res,
                    content: res.data?.content,
                }
            })
            .catch((err) => {
                customToast.error(err.response)
            })

        if (addResult?.content) {
            await handleReqFetchRackLocations()
            handleCloseSettingRackLocationModal()
            setTargetRackLocation(null)
        }
        CustomBackdropController().hideBackdrop()
    }

    const handleSetSearchQuery = async (newAddressSearchQueryDatas, newConditionSearchQueryDatas) => {
        setAddressSearchQueryDatas(newAddressSearchQueryDatas)
        setConditionSearchQueryDatas(newConditionSearchQueryDatas)
    }

    const handleResetSearchQuery = async () => {
        await handleReqFetchRackLocations()
        setAddressSearchQueryDatas({
            rack: "",
            bay: "",
            level: "",
            position: "",
        })
        setConditionSearchQueryDatas({
            productName: "",
            optionName: "",
            optionCode: "",
        })
        handleChamngeLocationTypeSearchQuery("ALL")
    }

    const handleChamngeLocationTypeSearchQuery = (newLocationTypeSearchQuery) => {
        setLocationTypeSearchQuery(newLocationTypeSearchQuery)
    }

    const filteredRackLocations = rackLocations
        ?.filter((rackLocation) => {
            const addressSplit = rackLocation.address.split("-")
            const centerNumber = addressSplit[0]
            const rackNumber = addressSplit[1]
            const bayNumber = addressSplit[2]
            const levelNumber = addressSplit[3]
            const positionNumber = addressSplit[4]

            if (
                (locationTypeSearchQuery === "ALL" || rackLocation?.type === locationTypeSearchQuery) &&
                rackNumber?.toLowerCase().includes(addressSearchQueryDatas?.rack.toLowerCase()) &&
                bayNumber?.toLowerCase().includes(addressSearchQueryDatas?.bay.toLowerCase()) &&
                levelNumber?.toLowerCase().includes(addressSearchQueryDatas?.level.toLowerCase()) &&
                positionNumber?.toLowerCase().includes(addressSearchQueryDatas?.position.toLowerCase())
            ) {
                return true
            }
            return false
        })
        ?.filter((rackLocation) => {
            if (
                !conditionSearchQueryDatas?.productName &&
                !conditionSearchQueryDatas?.optionName &&
                !conditionSearchQueryDatas?.optionCode
            ) {
                return true
            }

            const filteredItems = rackLocation?.items?.filter((item) => {
                if (
                    item?.productName?.includes(conditionSearchQueryDatas?.productName) &&
                    item?.optionName?.includes(conditionSearchQueryDatas?.optionName) &&
                    item?.optionCode?.includes(conditionSearchQueryDatas?.optionCode)
                ) {
                    return true
                } else {
                    return false
                }
            })
            if (filteredItems?.length > 0) {
                return true
            } else {
                return false
            }
        })
        ?.map((rackLocation) => {
            const filteredItems = rackLocation?.items
            return {
                ...rackLocation,
                items: filteredItems,
            }
        })
        ?.sort((a, b) => {
            if (a.address < b.address) return -1
            if (a.address > b.address) return 1
            return 0
        })

    return (
        <>
            <St.Container>
                <St.TopButtons>
                    <CustomBlockButton onClick={() => handleOpenCreateRackLocationModal()}>로케이션 생성</CustomBlockButton>
                    <CustomBlockButton
                        onClick={() => {
                            navigate("/rack-location-backup")
                        }}
                    >
                        백업
                    </CustomBlockButton>
                </St.TopButtons>
                <St.LocationCount.Container>
                    <div className="flex gap-2">
                        <div>
                            <span style={{ color: "var(--greenColor1)" }}>NORMAL</span> :{" "}
                            {rackLocations?.filter((r) => r.type === "NORMAL")?.length}개
                        </div>
                        <div>
                            <span style={{ color: "var(--greenColor1)" }}>사용가능</span> :{" "}
                            {rackLocations?.filter((r) => r.type === "NORMAL" && r.enabledYn === "y")?.length}개
                        </div>
                        <div>
                            <span style={{ color: "var(--redColor1)" }}>사용불가</span> :{" "}
                            {rackLocations?.filter((r) => r.type === "NORMAL" && r.enabledYn === "n")?.length}개
                        </div>
                    </div>
                    <div className="flex gap-2">
                        <div>
                            <span style={{ color: "var(--blueColor1)" }}>INVENTORY</span> :{" "}
                            {rackLocations?.filter((r) => r.type === "INVENTORY")?.length}개
                        </div>
                        <div>
                            <span style={{ color: "var(--greenColor1)" }}>사용가능</span> :{" "}
                            {rackLocations?.filter((r) => r.type === "INVENTORY" && r.enabledYn === "y")?.length}개
                        </div>
                        <div>
                            <span style={{ color: "var(--redColor1)" }}>사용불가</span> :{" "}
                            {rackLocations?.filter((r) => r.type === "INVENTORY" && r.enabledYn === "n")?.length}개
                        </div>
                    </div>
                </St.LocationCount.Container>
                {(() => {
                    const isConditionSearchActive = !!(
                        conditionSearchQueryDatas?.productName ||
                        conditionSearchQueryDatas?.optionName ||
                        conditionSearchQueryDatas?.optionCode
                    )
                    const allUUIDs = filteredRackLocations?.map((r) => r?.uuid) || []

                    return (
                        <>
                            <St.StickyArea>
                                <div className="head">
                                    <button
                                        type="button"
                                        className="searchToggle"
                                        onClick={() => setSearchOpen((v) => !v)}
                                    >
                                        🔍 검색/필터 {searchOpen ? "▲" : "▼"}
                                    </button>
                                    <span className="count">로케이션 {filteredRackLocations?.length || 0}개</span>
                                    {locationTypeSearchQuery === "ALL" && (
                                        <span
                                            className="typeChip"
                                            onClick={() => handleChamngeLocationTypeSearchQuery("NORMAL")}
                                            style={{ border: "1px solid #e0e0e0", background: "#fff" }}
                                        >
                                            전체
                                        </span>
                                    )}
                                    {locationTypeSearchQuery === "NORMAL" && (
                                        <span
                                            className="typeChip"
                                            onClick={() => handleChamngeLocationTypeSearchQuery("INVENTORY")}
                                            style={{ border: "1px solid #22c55e", background: "#f0fdf4", color: "#16a34a" }}
                                        >
                                            NORMAL
                                        </span>
                                    )}
                                    {locationTypeSearchQuery === "INVENTORY" && (
                                        <span
                                            className="typeChip"
                                            onClick={() => handleChamngeLocationTypeSearchQuery("ALL")}
                                            style={{ border: "1px solid #3b82f6", background: "#eff6ff", color: "#2563eb" }}
                                        >
                                            INVENTORY
                                        </span>
                                    )}
                                    <div className="expandButtons">
                                        <button type="button" onClick={() => handleExpandAll(allUUIDs)}>전체 펼치기</button>
                                        <button type="button" onClick={() => handleCollapseAll()}>전체 접기</button>
                                    </div>
                                </div>
                                {searchOpen && (
                                    <WegetSearchLocation
                                        addressSearchQueryDatas={addressSearchQueryDatas}
                                        onSetSearchQuery={handleSetSearchQuery}
                                        onResetSearchQuery={handleResetSearchQuery}
                                    />
                                )}
                            </St.StickyArea>

                            <StCard.List>
                                {filteredRackLocations?.map((rackLocation) => {
                                    const splitedAddress = rackLocation.address.split("-")
                                    const rackNumber = splitedAddress[1]
                                    const isSelected = selectedRackLocations?.find((r) => r.uuid === rackLocation?.uuid) ? true : false
                                    const itemCount = rackLocation?.items?.length || 0
                                    const expanded = isConditionSearchActive || expandedLocationUUIDs.has(rackLocation?.uuid)
                                    const addressColor = rackNumber.charCodeAt() % 2 === 0 ? "#9333ea" : "#334155"

                                    return (
                                        <StCard.Card key={rackLocation?.uuid} className={isSelected ? "selected" : ""}>
                                            <StCard.Header onClick={() => handleToggleExpand(rackLocation?.uuid)}>
                                                <StCard.SelectCheck
                                                    type="button"
                                                    className={isSelected ? "checked" : ""}
                                                    aria-label="로케이션 선택"
                                                    onClick={(e) => {
                                                        e.stopPropagation()
                                                        handleSelectRackLocation(rackLocation)
                                                    }}
                                                >
                                                    ✓
                                                </StCard.SelectCheck>
                                                <StCard.HeaderMain>
                                                    <div className="addressRow">
                                                        <span className="address" style={{ color: addressColor }}>
                                                            {rackLocation.address}
                                                        </span>
                                                        <StCard.TypeBadge className={rackLocation.type}>
                                                            {rackLocation.type}
                                                        </StCard.TypeBadge>
                                                    </div>
                                                    <div className="metaRow">
                                                        <StTable.StatusBadge $status={rackLocation.enabledYn}>
                                                            {rackLocation.enabledYn === "y" ? "사용가능" : "사용불가"}
                                                        </StTable.StatusBadge>
                                                        <span className="count">상품 {itemCount}종</span>
                                                        {rackLocation?.linkToLocationAddress && (
                                                            <span className="link">→ {rackLocation.linkToLocationAddress}</span>
                                                        )}
                                                    </div>
                                                </StCard.HeaderMain>
                                                <StCard.IconButton
                                                    type="button"
                                                    aria-label="로케이션 작업"
                                                    onClick={(e) => handleOpenActionMenu(e, rackLocation)}
                                                >
                                                    ⋯
                                                </StCard.IconButton>
                                                <StCard.Chevron className={expanded ? "open" : ""}>⌄</StCard.Chevron>
                                            </StCard.Header>

                                            {expanded && (
                                                <StCard.Body>
                                                    {itemCount === 0 ? (
                                                        <StCard.Empty>등록된 상품이 없습니다</StCard.Empty>
                                                    ) : (
                                                        <StCard.Products>
                                                            {rackLocation.items?.map((item) => (
                                                                <StCard.Product key={item?.uuid}>
                                                                    <div className="info">
                                                                        <div className="name">
                                                                            {highlightText(item.productName || "", conditionSearchQueryDatas?.productName)}
                                                                        </div>
                                                                        <div className="sub">
                                                                            {highlightText(item.optionName || "", conditionSearchQueryDatas?.optionName)}
                                                                            {item.optionCode && (
                                                                                <>
                                                                                    <span className="dot">·</span>
                                                                                    {highlightText(item.optionCode || "", conditionSearchQueryDatas?.optionCode)}
                                                                                </>
                                                                            )}
                                                                        </div>
                                                                    </div>
                                                                    <div className="qty">
                                                                        <span className="chip">수량 {item.productQuantity || 0}</span>
                                                                        <span className="chip box">BOX {item.boxQuantity || 0}</span>
                                                                    </div>
                                                                </StCard.Product>
                                                            ))}
                                                        </StCard.Products>
                                                    )}
                                                </StCard.Body>
                                            )}
                                        </StCard.Card>
                                    )
                                })}
                                {(!filteredRackLocations || filteredRackLocations.length === 0) && (
                                    <StCard.Empty style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: "12px" }}>
                                        표시할 로케이션이 없습니다
                                    </StCard.Empty>
                                )}
                            </StCard.List>

                            <Menu
                                anchorEl={actionMenu.anchorEl}
                                open={Boolean(actionMenu.anchorEl)}
                                onClose={handleCloseActionMenu}
                                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                                transformOrigin={{ vertical: "top", horizontal: "right" }}
                            >
                                <MenuItem onClick={() => handleActionMenuSelect("setting")}>설정</MenuItem>
                                <MenuItem onClick={() => handleActionMenuSelect("move")}>이동</MenuItem>
                                <MenuItem onClick={() => handleActionMenuSelect("backup")}>백업</MenuItem>
                            </Menu>
                        </>
                    )
                })()}
                {selectedRackLocations?.length > 0 && (
                    <St.EventField.Container>
                        <St.EventField.SelectedLocations>
                            <div className="label">선택된 로케이션 ({selectedRackLocations?.length}개)</div>
                            <div className="list">
                                {selectedRackLocations?.map((selectedRackLocation) => {
                                    return (
                                        <div
                                            key={selectedRackLocation?.uuid}
                                            className="item"
                                            onClick={() => handleSelectRackLocation(selectedRackLocation)}
                                        >
                                            {selectedRackLocation?.address}
                                        </div>
                                    )
                                })}
                            </div>
                        </St.EventField.SelectedLocations>
                        <St.EventField.Buttons>
                            <CustomBlockButton type="button" onClick={() => handleOpenEditLocationTypeModal()}>
                                로케이션 타입 일괄 변경
                            </CustomBlockButton>
                        </St.EventField.Buttons>
                    </St.EventField.Container>
                )}
            </St.Container>

            {createRackLocationModalOpen && (
                <CreateRackLocationModal
                    open={createRackLocationModalOpen}
                    onClose={handleCloseCreateRackLocationModal}
                    onAddNewRackLocations={handleAddNewRackLocations}
                />
            )}
            {settingRackLocationModalOpen && targetRackLocation && (
                <WegetSettingRackLocationModal
                    open={settingRackLocationModalOpen}
                    onClose={handleCloseSettingRackLocationModal}
                    rackLocations={rackLocations}
                    targetRackLocation={targetRackLocation}
                    onSaveTargetRackLocation={handleSaveTargetRackLocation}
                    onDeleteRackLocation={handleDeleteRackLocation}
                />
            )}
            {editLocationTypeModalOpen && (
                <WegetEditLocationTypeModal
                    open={editLocationTypeModalOpen}
                    onClose={handleCloseEditLocationTypeModal}
                    selectedRackLocations={selectedRackLocations}
                    onUpdateRackLocations={handleUpdateRackLocations}
                />
            )}

            {moveItemsModalOpen && (
                <WegetMoveItemsModal
                    open={moveItemsModalOpen}
                    onClose={handleCloseMoveItemsModal}
                    originRackLocation={targetRackLocation}
                    onReqFetchRackLocations={handleReqFetchRackLocations}
                />
            )}

            {backupModalOpen && (
                <WegetBackupModal
                    open={backupModalOpen}
                    onClose={handleCloseBackupModal}
                    targetRackLocation={targetRackLocation}
                    onReqFetchRackLocations={handleReqFetchRackLocations}
                />
            )}
        </>
    )
}

function CreateRackLocationModal({ open, onClose, onAddNewRackLocations }) {
    const centerNumber = "Z"
    const [rackNumbers, setRackNumbers] = useState("")
    const [bayNumbers, setBayNumbers] = useState("")
    const [levelNumbers, setLevelNumbers] = useState("")
    const [positionNumbers, setPositionNumbers] = useState("")
    const [rackLocations, setRackLocations] = useState([])

    const handleChangeRackNumbers = (e) => {
        const value = e.target.value
        setRackNumbers(value)
    }

    const handleChangeBayNumbers = (e) => {
        const value = e.target.value
        setBayNumbers(value)
    }

    const handleChangeLevelNumbers = (e) => {
        const value = e.target.value
        setLevelNumbers(value)
    }

    const handleChangePositionNumbers = (e) => {
        const value = e.target.value
        setPositionNumbers(value)
    }

    const handleCreateRackLocations = () => {
        if (!rackNumbers || !bayNumbers || !levelNumbers || !positionNumbers) {
            alert("로케이션 요소들을 입력해 주세요.")
            return
        }

        const rackNumbersSplit = rackNumbers
            ?.trim()
            ?.split(",")
            ?.map((r) => r?.trim())
        const bayNumbersSplit = bayNumbers
            ?.trim()
            ?.split(",")
            ?.map((r) => r?.trim())
        const levelNumbersSplit = levelNumbers
            ?.trim()
            ?.split(",")
            ?.map((r) => r?.trim())
        const positionNumbersSplit = positionNumbers
            ?.trim()
            ?.split(",")
            ?.map((r) => r?.trim())
        const newRackLocations = []

        rackNumbersSplit.forEach((rack) => {
            bayNumbersSplit.forEach((bay) => {
                levelNumbersSplit.forEach((level) => {
                    positionNumbersSplit.forEach((position) => {
                        newRackLocations.push({
                            id: null,
                            uuid: uuidv4(),
                            type: "NORMAL",
                            address: `${centerNumber}-${rack}-${bay}-${level}-${position}`,
                            enabledYn: "y",
                            linkToLocationAddress: "",
                            items: [],
                            allowedWidth: 1100,
                            allowedDepth: 1100,
                            allowedHeight: 1550,
                        })
                    })
                })
            })
        })

        setRackLocations(newRackLocations)
    }

    const handleChangeType = (targetRackLocation) => {
        setRackLocations((prev) => {
            return prev.map((r) => {
                if (r.uuid === targetRackLocation?.uuid) {
                    return {
                        ...r,
                        type: r.type === "NORMAL" ? "INVENTORY" : "NORMAL",
                    }
                }
                return { ...r }
            })
        })
    }

    const handleSave = async () => {
        await onAddNewRackLocations(rackLocations)
    }

    return (
        <CustomDialog open={open}>
            <St.CreateRackLocationModal.HeaderContainer>
                <CustomDialog.Header>
                    <CustomDialog.Header.Fake />
                    <CustomDialog.Header.Title>로케이션 생성</CustomDialog.Header.Title>
                    <CustomDialog.Header.Close onClick={() => onClose()} />
                </CustomDialog.Header>
            </St.CreateRackLocationModal.HeaderContainer>
            <St.CreateRackLocationModal.AddConditionsContainer>
                <CustomLabelInput className="inputBox">
                    <CustomLabelInput.Input type="text" defaultValue={centerNumber} disabled />
                    <CustomLabelInput.Label>센터No.</CustomLabelInput.Label>
                </CustomLabelInput>
                <CustomLabelInput className="inputBox">
                    <CustomLabelInput.Input type="text" value={rackNumbers || ""} onChange={handleChangeRackNumbers} />
                    <CustomLabelInput.Label>RackNo. 콤마(,)로 구분</CustomLabelInput.Label>
                </CustomLabelInput>
                <CustomLabelInput className="inputBox">
                    <CustomLabelInput.Input type="text" value={bayNumbers || ""} onChange={handleChangeBayNumbers} />
                    <CustomLabelInput.Label>BayNo. 콤마(,)로 구분</CustomLabelInput.Label>
                </CustomLabelInput>
                <CustomLabelInput className="inputBox">
                    <CustomLabelInput.Input type="text" value={levelNumbers || ""} onChange={handleChangeLevelNumbers} />
                    <CustomLabelInput.Label>LevelNo. 콤마(,)로 구분</CustomLabelInput.Label>
                </CustomLabelInput>
                <CustomLabelInput className="inputBox">
                    <CustomLabelInput.Input type="text" value={positionNumbers || ""} onChange={handleChangePositionNumbers} />
                    <CustomLabelInput.Label>PositionNo. 콤마(,)로 구분</CustomLabelInput.Label>
                </CustomLabelInput>
                <CustomBlockButton type="button" onClick={() => handleCreateRackLocations()}>
                    로케이션 넘버 생성
                </CustomBlockButton>
            </St.CreateRackLocationModal.AddConditionsContainer>
            <St.CreateRackLocationModal.RackLocationsContainer>
                {rackLocations?.map((rackLocation) => {
                    return (
                        <div key={rackLocation.uuid} className="itemBox">
                            <div className="address">{rackLocation?.address}</div>
                            <CustomBlockButton
                                type="button"
                                className={`type ${rackLocation?.type === "NORMAL" ? "normal" : "inventory"}`}
                                onClick={() => handleChangeType(rackLocation)}
                            >
                                {rackLocation?.type}
                            </CustomBlockButton>
                        </div>
                    )
                })}
            </St.CreateRackLocationModal.RackLocationsContainer>
            <St.CreateRackLocationModal.SaveContainer>
                <CustomBlockButton type="button" onClick={() => handleSave()}>
                    저장
                </CustomBlockButton>
            </St.CreateRackLocationModal.SaveContainer>
        </CustomDialog>
    )
}

const highlightText = (text, searchQuery) => {
    if (!searchQuery) return text
    const regex = new RegExp(`(${searchQuery})`, "gi")
    const parts = text.split(regex)
    return parts.map((part, index) => (regex.test(part) ? <mark key={index}>{part}</mark> : part))
}
